import { render, staticRenderFns } from "./account-background.vue?vue&type=template&id=6ed4812e"
import script from "./account-background.vue?vue&type=script&lang=js"
export * from "./account-background.vue?vue&type=script&lang=js"
import style0 from "./account-background.vue?vue&type=style&index=0&id=6ed4812e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../Shield.UI.CommsManagerWebsite/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports